export const itemsData = [
  { letter: "S", text: "service" },
  { letter: "P", text: "professionalism" },
  { letter: "I", text: "innovation" },
  { letter: "R", text: "respect" },
  { letter: "I", text: "integrity" },
  { letter: "T", text: "team spirit" },
];
